import { BaseApi } from '@bv/api/base';

export const contactIdentifierTypeOptions = [
  { label: 'Contact ID', value: 'contact_id' },
  { label: 'Conversation ID', value: 'conversation_id' },
  { label: 'Phone Number', value: 'phone_number' },
  { label: 'Email', value: 'email' },
];

interface GenerateWebhookResponse {
  token?: string;
  webhookToken?: string;
  url?: string;
  webhookUrl?: string;
}

class WorkflowWebhookApi extends BaseApi {
  constructor() {
    super('flow/workflows/webhook');
  }

  async generate(existingToken?: string): Promise<{ webhookToken: string; webhookUrl: string }> {
    const response = await this.request<GenerateWebhookResponse>({
      method: 'get',
      url: 'generate',
      data: existingToken ? { token: existingToken } : undefined,
    });

    const payload = ((response as { data?: GenerateWebhookResponse }).data ?? response) as GenerateWebhookResponse;
    const webhookToken = payload.webhookToken ?? payload.token ?? '';
    const webhookUrl = payload.webhookUrl ?? payload.url ?? buildWebhookUrl(webhookToken);

    return { webhookToken, webhookUrl };
  }
}

const workflowWebhookApi = new WorkflowWebhookApi();

export const buildWebhookUrl = (token: string): string => {
  if (!token) {
    return '';
  }

  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
  const apiVersion = import.meta.env.VITE_API_VERSION;

  return `${apiBaseUrl}/${apiVersion}/trigger-workflow/webhooks/workflows/${token}`;
};

export const generateWebhookCredentials = async (existingToken?: string) => {
  return workflowWebhookApi.generate(existingToken);
};

export const resolveWebhookUrl = (data: Record<string, unknown>): string => {
  const storedUrl = data.webhookUrl;
  if (typeof storedUrl === 'string' && storedUrl.trim()) {
    return storedUrl;
  }

  const token = data.webhookToken;
  if (typeof token === 'string' && token.trim()) {
    return buildWebhookUrl(token);
  }

  return '';
};
